const geolocateKey = 'AIzaSyDO-w3n9c1X4aq-wUXayUIm4U6gDTgMfb4';
const locationLsObj = 'horizons_loc';

// Get formatted today's date
const getDeviceDate = () => {
  const date = new Date();
  return (date.getMonth() + 1).toString() + date.getDate().toString() + date.getFullYear().toString();
};

const getAddressCoordinates = (address, callbacks) => {
  const geocoder = new google.maps.Geocoder(); /* eslint-disable-line no-undef */
  geocoder.geocode(
    { address },
    (results, status) => {
      // console.log(status);
      if (status === 'OK' && callbacks.success !== undefined) {
        // console.log(results);
        callbacks.success({
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        });
      } else if (status !== 'OK' && callbacks.fail !== undefined) {
        callbacks.fail();
      }
    },
  );
};

// Creates the object that gets passed to callback, saved in ls/cookie
const createLocObj = (lat, lng) => {
  const info = {
    date: getDeviceDate(),
    pos: {
      coords: {
        lat,
        lng,
      },
    },
  };
  // Save in local storage
  window.localStorage.setItem(locationLsObj, JSON.stringify(info));
  // Returns just position object
  return info.pos;
};

/**
 * Get device's location
 * Uses's google maps api, rate limited to 2500 calls/day, 50/minute
 * Need to update key before moving to production, or should actually add dev/production keys
 * @param callbacks: {
      success: <method>,
      fail: <method>
    }
 * @returns Function
 * @param pos Object (coords)
*/
const getDeviceLocation = (callbacks) => {
  // Check if cookie exists
  // Check to see if user has already accessed locator service today
  // Otherwise, check location again, may have moved...
  let lastAccessDate;
  const lsData = JSON.parse(window.localStorage.getItem(locationLsObj));
  if (lsData !== null) {
    lastAccessDate = lsData.date;
  }
  // console.log(`${getDeviceDate()}/${lastAccessDate}`);
  if (getDeviceDate() === lastAccessDate) {
    // console.log(`getDeviceLocation, last accessed on:${lastAccessDate}, use ${lsData.pos.coords.lat}, ${lsData.pos.coords.lng}`);
    // SUCCESS
    if (callbacks.success !== undefined) {
      callbacks.success(lsData.pos);
    }
  } else {
    // Reset device access date to now
    const requestUrl = `https://www.googleapis.com/geolocation/v1/geolocate?key=${geolocateKey}`;
    const request = new XMLHttpRequest();
    request.open('POST', requestUrl, true);
    request.setRequestHeader('Content-type', 'application/json; charset=utf-8');

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText);
        // SUCCESS
        if (callbacks.success !== undefined) {
          callbacks.success(createLocObj(
            data.location.lat,
            data.location.lng,
          ));
        }
      }
    };

    request.onerror = () => {
      const data = JSON.parse(request.responseText);
      if (data.location === undefined) {
        // FAIL
        // Consider using browser-based here as fallback
        if (callbacks.fail !== undefined) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              // SUCCESS
              if (callbacks.success !== undefined) {
                callbacks.success(createLocObj(
                  position.coords.latitude,
                  position.coords.longitude,
                ));
              }
            });
          } else {
            // FAIL
            // Browser doesn't support Geolocation
            /* eslint-disable no-lonely-if */
            if (callbacks.fail !== undefined) {
              callbacks.fail();
            }
            /* eslint-enable no-lonely-if */
          }
        }
      } else {
        // Assume success, idk why 200s throw fail
        // SUCCESS
        /* eslint-disable no-lonely-if */
        if (callbacks.success !== undefined) {
          callbacks.success(createLocObj(
            data.location.lat,
            data.location.lng,
          ));
        }
        /* eslint-enable no-lonely-if */
      }
    };

    request.send();
  }
};

export {
  getAddressCoordinates,
  getDeviceDate,
  getDeviceLocation,
};
